import {
  Box,
  Grid,
  MenuItem,
  TextField,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  useTheme,
  useMediaQuery,
  Checkbox,
} from "@mui/material";
import RootComponents from "../../components/common/RootComponents";
import styles from "./PostRequirement.module.css";
import { useEffect, useRef, useState } from "react";
import { ThemeProvider } from "@mui/material/styles";
import image from "../../assets/images/Hiring-rafiki.png";
import attachement from "../../assets/images/attach.png"
import resume from "../../assets/images/resume.png"
import { customTextColor } from "../../utils/const";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { createPostRequirement, updatePostRequirement } from "../../redux/post-requirement/postRequirementSlice";
import { useLocation } from "react-router-dom";
import profile_image from "../../assets/images/ajit_image.jpeg";

const label = { inputProps: { "aria-label": "Checkbox demo" } };
const job = [
  { value: "Full_Time", label: "Full Time" },
  { value: "Contract", label: "Contract" },
  { value: "W2", label: "W2" },
  { value: "1099", label: "1099" },
  { value: "Contract_To_Hire", label: "Contract To Hire" },
];

const locations = [
  { value: "california", label: "California" },
  { value: "taxes", label: "Texas" },
];

const work = [
  { value: "GC", label: "GC" },
  { value: "USC", label: "USC" },
];

const preference = [
  { value: "Onsite", label: "Onsite" },
  { value: "Hybrid", label: "Hybrid" },
  { value: "Remote", label: "Remote" },
];

const mode = [
  { value: "Phone", label: "Phone" },
  { value: "Virtual", label: "Virtual" },
  { value: "Inperson", label: "In Person" },
];

const post = [
  { value: "benchsales", label: "Bench Sales" },
  { value: "benchsales&candidate", label: "Bench Sales & Candidate " },
];

const limit = [
  { value: "min", label: "Minimum " },
  { value: "max", label: "Maximum " },
];

const respond = [
  { value: "1hour", label: "1 Hour" },
  { value: "5hour", label: "5 Hour" },
  { value: "1day", label: "1 Day" },
  { value: "5days", label: "5 Days" },
  { value: "7days", label: "7 Days" },
];

const report = [
  { value: "throughemail", label: "Through Email" },
  { value: "povitalaccount", label: "Povital Account" },
];

const authirization = [
  {
    value: "GC", label: "GC"
  }
]
const customStyle = { width: "100%", padding: '3px', "& .MuiInputLabel-root": { fontSize: '14px' } }

const PostJobRequirement = () => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [open, setOpen] = useState(false);
  const [showAttachments, setShowAttachments] = useState(false)
  const dispatch = useDispatch()
  const location = useLocation();
  const { row } = location?.state || {};
  const postRequirementStatus = useSelector((state) => state.postrequirement.status)
  let jobId = row?.job_id;

  const [text, setText] = useState('');
  const textareaRef = useRef(null);

  const handleChange = (event) => {
    setText(event.target.value);
  };

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto'; // Reset the height
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`; // Adjust to scroll height
    }
  }, [text]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleAddAttachmentClick = () => {
    setShowAttachments(!showAttachments);
  };
  const formik = useFormik({
    initialValues: {
      job_title: row?.job_title || "",
      job_description: row?.job_description || "",
      experience: row?.experience || "",
      job_type: row?.job_type || "",
      work_preference: row?.work_preference || "",
      location: row?.location || "",
      work_authorization: row?.work_authorization || "",
      mode_of_interview: row?.mode_of_interview || "",
      rate: row?.rate || "",
    },
    validationSchema: Yup.object({
      job_title: Yup.string().required("Job Title is required"),
      job_description: Yup.string().required("Job Description is required"),
      experience: Yup.string().required("Experience is required"),
      job_type: Yup.string().required("Hirring Mode is required"),
      work_preference: Yup.string().required("Work Preference is required"),
      location: Yup.string().required("Location is required"),
      work_authorization: Yup.string().required(
        "Work Authorization is required"
      ),
      mode_of_interview: Yup.string().required("Mode Of Interview is required"),
      rate: Yup.string().required("Rate is required"),
    }),
    onSubmit: (values) => {
      if (row !== undefined && row !== null) {
        dispatch(updatePostRequirement({ values, jobId }));
      } else {
        dispatch(createPostRequirement(values));
      }

    },
  });

  useEffect(() => {
    if (postRequirementStatus === "create_requirement_post") {
      handleClickOpen()
    }

  }, [postRequirementStatus])

  return (
    <ThemeProvider theme={theme}>
      {/* <RootComponents> */}
        <Box className={styles.post_required_view_structure}>
          <Box className={styles.post_job_header_text}>
            <Typography sx={{ color: customTextColor }}>Post Job Requirement</Typography>
          </Box>
          <form onSubmit={formik.handleSubmit}>
            <Grid container sx={{ backgroundColor: '#fff', paddingBottom: '10px' }}>
              <Grid item xs={12} sm={12} md={12} lg={12} sx={{ padding: "7px 15px 0" }}>
                <TextField
                  label="Job Headline"
                  variant="standard"
                  sx={customStyle}
                  InputLabelProps={{
                    sx: { marginLeft: "2px" },
                  }}
                />

              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6} sx={{ padding: "7px 15px 0" }}>
                <TextField
                  label="Job Title"
                  variant="standard"
                  sx={customStyle}
                  name="job_title"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.job_title}
                  InputLabelProps={{
                    sx: { marginLeft: "2px" },
                  }}
                />
                {formik.touched.job_title &&
                  formik.errors.job_title ? (
                  <div className={styles.error}>
                    {formik.errors.job_title}
                  </div>
                ) : null}
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6} sx={{ padding: "7px 15px 0" }}>
                <TextField
                  label="Experience"
                  variant="standard"
                  type="number"
                  name="experience"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.experience}
                  sx={customStyle}
                  InputLabelProps={{
                    sx: { marginLeft: "2px" },
                  }}
                />
                {formik.touched.experience &&
                  formik.errors.experience ? (
                  <div className={styles.error}>
                    {formik.errors.experience}
                  </div>
                ) : null}
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6} sx={{ padding: "7px 15px 0" }}>
                <TextField
                  select
                  label="Location"
                  variant="standard"
                  name="location"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.location}
                  sx={customStyle}
                  InputLabelProps={{
                    sx: { marginLeft: "2px" },
                  }}
                >
                  {locations?.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
                {formik.touched.location &&
                  formik.errors.location ? (
                  <div className={styles.error}>
                    {formik.errors.location}
                  </div>
                ) : null}
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6} sx={{ padding: "7px 15px 0" }}>
                <TextField
                  select
                  variant="standard"
                  label="Mode of Hiring"
                  name="job_type"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.job_type}
                  sx={customStyle}
                  InputLabelProps={{
                    sx: { marginLeft: "2px" },
                  }}
                >
                  {job.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
                {formik.touched.job_type &&
                  formik.errors.job_type ? (
                  <div className={styles.error}>
                    {formik.errors.job_type}
                  </div>
                ) : null}
              </Grid>
              {formik.values.job_type === "Contract" || formik.values.job_type === "W2" ? (
                <Grid item xs={12} sm={6} md={6} lg={6} sx={{ padding: "7px 15px 0" }}>
                  <TextField
                    label="Duration"
                    variant="standard"
                    sx={customStyle}
                    InputLabelProps={{
                      sx: { marginLeft: "2px" },
                    }}
                  />

                </Grid>
              ) : null}
              {/* {formik.values.job_type === "Full_Time" || formik.values.job_type === "Contract" || formik.values.job_type === "W2" ? (
                <Grid item xs={12} sm={6} md={6} lg={6} sx={{ padding: "7px 15px 0" }}>
                  <TextField
                    select
                    variant="standard"
                    label="Work Authorization"
                    name="work_authorization"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.work_authorization}
                    sx={{ width: "100%", padding: '3px' }}
                    InputLabelProps={{
                      sx: { marginLeft: "2px" },
                    }}
                  >
                    {work.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                  {formik.touched.work_authorization &&
                    formik.errors.work_authorization ? (
                    <div className={styles.error}>
                      {formik.errors.work_authorization}
                    </div>
                  ) : null}
                </Grid>
              ) : null} */}
              <Grid item xs={12} sm={6} md={6} lg={6} sx={{ padding: "7px 15px 0" }}>
                <TextField
                  select
                  variant="standard"
                  label="Work Preference"
                  name="work_preference"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.work_preference}
                  sx={customStyle}
                  InputLabelProps={{
                    sx: { marginLeft: "2px" },
                  }}
                >
                  {preference.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
                {formik.touched.work_preference &&
                  formik.errors.work_preference ? (
                  <div className={styles.error}>
                    {formik.errors.work_preference}
                  </div>
                ) : null}
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6} sx={{ padding: "7px 15px 0" }}>
                <TextField
                  select
                  variant="standard"
                  label="Mode of Interview"
                  name="mode_of_interview"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.mode_of_interview}
                  sx={customStyle}
                  InputLabelProps={{
                    sx: { marginLeft: "2px" },
                  }}
                >
                  {mode.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>

                  ))}
                </TextField>
                {formik.touched.mode_of_interview &&
                  formik.errors.mode_of_interview ? (
                  <div className={styles.error}>
                    {formik.errors.mode_of_interview}
                  </div>
                ) : null}
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6} sx={{ padding: "7px 15px 0" }}>


                <TextField
                  select
                  variant="standard"
                  label="Work Authorization"
                  name="work_authorization"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.work_authorization}
                  sx={customStyle}
                  InputLabelProps={{
                    sx: { marginLeft: "2px" },
                  }}
                >
                  {authirization.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
                {formik.touched.work_authorization &&
                  formik.errors.work_authorization ? (
                  <div className={styles.error}>
                    {formik.errors.work_authorization}
                  </div>
                ) : null}
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6} sx={{ padding: "7px 15px 0" }}>
                <TextField
                  label="Rate"
                  variant="standard"
                  name="rate"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.rate}
                  sx={customStyle}
                  InputLabelProps={{
                    sx: { marginLeft: "2px" },
                  }}
                />
                {formik.touched.rate &&
                  formik.errors.rate ? (
                  <div className={styles.error}>
                    {formik.errors.rate}
                  </div>
                ) : null}
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6} sx={{ padding: "7px 15px 0" }}>
                <TextField
                  label="Client"
                  variant="standard"
                  sx={customStyle}
                  InputLabelProps={{
                    sx: { marginLeft: "2px" },
                  }}
                />

              </Grid>
              {/* <Grid item xs={12} sx={{ padding: "7px 15px 0", marginTop: '8px' }}>
                <TextField
                  label="Job Description"
                  multiline
                  rows={5}
                  name="job_description"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.job_description}
                  sx={{ width: "100%" }}
                />
                {formik.touched.job_description &&
                  formik.errors.job_description ? (
                  <div className={styles.error}>
                    {formik.errors.job_description}
                  </div>
                ) : null}
              </Grid>
              <Grid item xs={12} sx={{ padding: "7px 15px 0", marginTop: '8px' }}>
                <TextField
                  label="Mandatory Skills"
                  multiline
                  rows={3}
                  sx={{ width: "100%" }}
                />
              </Grid> */}
            </Grid>
            <Box className={styles.mandatory_description}>
              <Box sx={{ color: customTextColor }}>
                {/* <Typography sx={{ padding: '0 5px 30px 0' }}>Job description</Typography> */}
                <textarea class="form-control" id="exampleFormControlTextarea1" rows="5" placeholder="Job description" ref={textareaRef}
                  value={text}
                  onChange={handleChange} style={{ overflow: 'hidden', resize: 'none', border: 'none' }}></textarea>
                <hr style={{ marginBottom: '0' }}></hr>
                {/* <Typography >Mandatory Skills</Typography> */}
                <textarea style={{ border: 'none' }} class="form-control" id="exampleFormControlTextarea1" rows="3" placeholder="Mandatory Skills"></textarea>
              </Box>

            </Box>

            <div style={{ backgroundColor: '#fff', padding: '0 14px 14px ' }}>
              <span
                style={{ padding: '10px' }}
                className={styles.view_profile_link}
                onClick={handleAddAttachmentClick}
              >
                Add Attachment
              </span>
              {showAttachments && (
                <Grid container className={styles.download_section}>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6}
                    sx={{ padding: '14px 0 0  4px' }}
                  >
                    <span style={{ color: customTextColor }}>
                      <Typography>Client Submission format:</Typography>
                      <Typography sx={{ cursor: 'pointer', lineHeight: '0' }}>
                        <img src={attachement} alt="attachment" style={{ width: '25px' }} />
                      </Typography>
                    </span>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6}
                    sx={{ padding: '13px 4px 5px 15px' }}
                  >
                    <span style={{ color: customTextColor }}>
                      <Typography>Reference Resume/profile</Typography>
                      <Typography sx={{ cursor: 'pointer', lineHeight: '0' }}>
                        <img src={resume} alt="resume" style={{ width: '25px' }} />
                      </Typography>
                    </span>
                  </Grid>
                </Grid>
              )}

              {/* <Box className={styles.job_description} sx={{ backgroundColor: '#f0f2f5', padding: '0', borderRadius: '5px' }}>
                <Box sx={{ color: customTextColor, padding: '15px 15px 70px !important', border: '1px solid #ccc !important' }}>
                  <Typography>Recruiter Signature</Typography>
                </Box>
              </Box> */}

              <Box className={styles.recruiter_profile}>
                <div >
                  <img src={profile_image} alt="" />
                  <span style={{ color: customTextColor }}>
                    <Typography style={{ marginBottom: '12px ' }}>
                      <b>  Thanks & Regrads  </b>
                    </Typography>
                    <Typography>
                      <b> Ajit Kumar Gahan</b>
                    </Typography>
                    <Typography>
                      UI Designer at Tek Inspiration
                    </Typography>
                    <Typography sx={{ margin: "0 !important" }}>
                      E-mail: Ajit@tekinspirations.com,   Ph : 77012 54720
                    </Typography>

                  </span>
                </div>
              </Box>
            </div>
          </form>


          <Box className={styles.post_requiredment_btn}>
            <button onClick={formik.handleSubmit}>{row !== undefined && row !== null ? "Save Requirement" : "Post Requirement"}</button>
          </Box>
        </Box>
        <Dialog
          fullScreen={fullScreen}
          open={open}
          onClose={handleClose}
          aria-labelledby="responsive-dialog-title"
          maxWidth="md"
          fullWidth={true}
        >
          <Box className={styles.recruiter_matches_section}>
            <Box style={{ color: customTextColor }}>
              <Typography sx={{ fontSize: '30px !important' }}><b>1250</b></Typography>
              <Typography sx={{ fontWeight: '500 ', }}>Matches Bench Sales Recruiter for this post
              </Typography>
              <Typography sx={{ marginBottom: '0 !important', fontWeight: '400 !important' }}>500+ Newly enrollment Bench Sales Recruiter

              </Typography>
            </Box>

            <img src={image} alt="" />
          </Box>
          <DialogContent>

            <Box sx={{ margin: "10px" }}>
              <Typography>Hi Ashit Kumar</Typography>
              <Typography>
                This post will reach to matching and active user according post preference.
              </Typography>
              <Typography>Please instruct to Povital ATS  </Typography>
            </Box>
            <Grid container>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "10px" }}
              >
                <TextField
                  select
                  variant="standard"
                  label="Post categories"
                  sx={{ width: "100%" }}
                >
                  {post.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "10px" }}
              >
                <TextField
                  select
                  variant="standard"
                  label="Post reaching limit"
                  sx={{ width: "100%" }}
                >
                  {limit.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "10px" }}
              >
                <TextField
                  select
                  variant="standard"
                  label="Post available to respond"
                  sx={{ width: "100%" }}
                >
                  {respond.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "10px" }}
              >
                <TextField
                  select
                  variant="standard"
                  label="Need post report"
                  sx={{ width: "100%" }}
                >
                  {report.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Box sx={{ padding: "10px 0" }}>
                <Typography
                  className={styles.profile_check_list}
                  sx={{ margin: "10px" }}
                >
                  No repeat on repost
                  <Checkbox {...label} />
                </Typography>
              </Box>
              <Box sx={{ padding: "10px 0" }}>
                <Typography
                  className={styles.profile_check_list}
                  sx={{ margin: "10px" }}
                >
                  Do not send to block
                  <Checkbox {...label} />
                </Typography>
              </Box>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Box className={styles.post_btn}>
              <button
                onClick={handleClose}
              >
                {row !== undefined && row !== null ? "Save Requirement" : "Confirm"}
              </button>
            </Box>
          </DialogActions>
        </Dialog>
      {/* </RootComponents> */}
    </ThemeProvider>
  );
};

export default PostJobRequirement;
